class InvoiceService {
  constructor($http, $rootScope) {
    'ngInject';

    this.$http = $http;
    this.baseUrl = `${$rootScope.apiHost}/api/admin/invoices`;
    this.httpOptions = { withCredentials: true };
  }

  getAvailableLineItems(invoiceId) {
    return this.$http.get(
      `${this.baseUrl}/${invoiceId}/available-line-items`,
      this.httpOptions
    );
  }

  addLineItems(invoiceId, selectedRows) {
    const lineItems = (selectedRows || []).map((row) => {
      const laborCategory = row.laborCategory
        || (row.chargeCode && row.chargeCode.popRate && row.chargeCode.popRate.laborCategory);

      return {
        user: { id: row.user.id },
        chargeCode: { id: row.chargeCode.id },
        laborCategory: { id: laborCategory.id }
      };
    });

    return this.$http.post(
      `${this.baseUrl}/${invoiceId}/lineitems`,
      { lineItems },
      this.httpOptions
    );
  }

  removeLineItem(invoiceId, lineItemId) {
    return this.$http.delete(
      `${this.baseUrl}/${invoiceId}/lineitems/${lineItemId}`,
      this.httpOptions
    );
  }

  getTravelEligibleReports(projectId) {
    const params = {};
    if (projectId) {
      params.projectId = projectId;
    }
    return this.$http.get(
      `${this.baseUrl}/travel/eligible-reports`,
      Object.assign({}, this.httpOptions, { params })
    );
  }

  getTravelCategoryCumulatives(projectId) {
    return this.$http.get(
      `${this.baseUrl}/travel/category-cumulatives`,
      Object.assign({}, this.httpOptions, { params: { projectId } })
    );
  }

  createTravelInvoice(payload) {
    return this.$http.post(
      `${this.baseUrl}/travel`,
      payload,
      this.httpOptions
    );
  }

  formatInvoiceNumber(invoice) {
    if (!invoice) {
      return '';
    }
    if (invoice.invoiceNumberLabel) {
      return String(invoice.invoiceNumberLabel);
    }
    const number = invoice.invoiceNumber;
    if (invoice.invoiceType && String(invoice.invoiceType).toUpperCase() === 'TRAVEL') {
      return number + '-TRAVEL';
    }
    return String(number);
  }

  getInvoiceTypeLabel(invoice) {
    if (!invoice || !invoice.invoiceType) {
      return 'Labor';
    }
    const type = String(invoice.invoiceType).toUpperCase();
    if (type === 'TRAVEL') {
      return 'Travel';
    }
    if (type === 'OTHER') {
      return 'Other';
    }
    return 'Labor';
  }

  isTravelInvoice(invoice) {
    return !!(invoice && invoice.invoiceType
      && String(invoice.invoiceType).toUpperCase() === 'TRAVEL');
  }
}

export default InvoiceService;



// WEBPACK FOOTER //
// ./client/common/services/invoices/invoice.service.js